import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  const logEvent = (category, action, label) => {
    ReactGA.event({
      category,
      action,
      label
    });
  };

  return { logEvent };
}; 